import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '../../components';

import css from './AboutPage.module.css';

import element1 from '../../assets/team-shape1.png';
import element2 from '../../assets/team-shape2.png';
import element3 from '../../assets/team-shape3.png';
import element4 from '../../assets/team-shape4.png';
import teamImg1 from '../../assets/team-img1.png';
import teamImg2 from '../../assets/team-img2.png';
import teamImg3 from '../../assets/team-img3.png';
import IconLinkedin from '../../components/IconLinkedin/IconLinkedin';
import { isLocaleGreek } from '../../util/genericHelpers';

function SectionOurTeam() {
  return (
    <div className={css.ourTeamContainer}>
      <span className={css.shape1}>
        <img src={element1} alt="element" />
      </span>
      <span className={css.shape2}>
        <img src={element2} alt="element" />
      </span>
      <span className={css.shape3}>
        <img src={element3} alt="element" />
      </span>
      <span className={css.shape4}>
        <img src={element4} alt="element" />
      </span>
      <div className={css.contentWidth}>
        <div className={css.ourTeamContent}>
          <h2>
            <FormattedMessage id="AboutPage.ourTeamHeading" />
          </h2>
          <div className={css.teamBlock}>
            <div className={css.team}>
              <div className={css.teamInfo}>
                <div className={css.teamImg}>
                  <img src={teamImg2} alt="Gina Tiriakidou" />
                </div>
                <h2>
                  <FormattedMessage id="AboutPage.employeeName1" />
                </h2>
                <h3>
                  <FormattedMessage id="AboutPage.employeePosition1" />
                   
                </h3>
                <p>
                  <FormattedMessage id="AboutPage.employeeInfo1" />
                </p>
              </div>
              <ExternalLink href="https://www.linkedin.com/in/gina-tiriakidou-3aa7067/?originalSubdomain=de">
                <IconLinkedin />
              </ExternalLink>
            </div>
            <div className={css.team}>
              <div className={css.teamInfo}>
                <div className={css.teamImg}>
                  <img src={teamImg1} alt="Elena Skoura" />
                </div>
                <h2>
                  <FormattedMessage id="AboutPage.employeeName2" />
                </h2>
                <h3>
                  <FormattedMessage id="AboutPage.employeePosition2" />
                </h3>
                <p>
                  <FormattedMessage id="AboutPage.employeeInfo2" />
                </p>
              </div>
              <ExternalLink href="https://www.linkedin.com/in/elenaskoura/?originalSubdomain=gr">
                <IconLinkedin />
              </ExternalLink>
            </div>
            <div className={css.team}>
              <div className={css.teamInfo}>
                <div className={css.teamImg}>
                  <img src={teamImg3} alt="Olga Skouteli" />
                </div>
                <h2>
                  <FormattedMessage id="AboutPage.employeeName3" />
                </h2>
                <h3>
                  <FormattedMessage id="AboutPage.employeePosition3" />   
                </h3>
                <p>
                  <FormattedMessage id="AboutPage.employeeInfo3" />
                </p>
              </div>
              <ExternalLink href="https://www.linkedin.com/in/olga-skouteli">
                <IconLinkedin />
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionOurTeam;
